import { axiosSecureInstance } from "./axios";
import { FETCH_SINGLE_USER_INFO } from "./user_api_constant";
import { GET_SINGLE_USER_PROFILE_API_SLUG,GET_USER_PROFILE_API_SLUG } from "../constants/Api_constants";

export const getUserData = async (userId, setRole) => {
  if (!userId) {
    return { success: false, error: "User ID is required" };
  }

  try {
    const userid = { userId };
    const response = await axiosSecureInstance.post(FETCH_SINGLE_USER_INFO(), userid);
    const userData = response?.data?.user;

    if (!userData) {
      return { success: false, error: "No user data found" };
    }

    setRole(userData.role);
    return { success: true, data: userData };
  } catch (error) {
    console.error("Error fetching user data:", error);
    setRole(null);
    return { success: false, error: error.message || "An error occurred" };
  }
};

  export const getUserAvatar = async (userId) => {
    try {
      const userid = {
        userId: userId,
      };
      if(!userId) {
        return null
      }
      const response = await axiosSecureInstance.post(
        FETCH_SINGLE_USER_INFO(),
        userid
      );
  
      return { success: true, data: response?.data?.user?.userAvatar };
    } catch (error) {
      return { success: false, error };
    }
  };

  export const getRoleOfUser = async (userId, userRole, setUserRole, setIsPublic) => {
    if (userId === null) {
      setUserRole("user");
      setIsPublic(false);
      return <p>Loading...</p>;
    } else {
      try {
        const response = await axiosSecureInstance.post(GET_USER_PROFILE_API_SLUG,{
          "userId" : userId
      });
        const userInfo = response.data.user.role;
        setUserRole(userInfo);
      } catch (error) {
        throw new Error(error);
      }
    }
  };

  export const getUserTeams = async (userId) => {
    if (!userId) {
      return { success: false, error: "User ID is required" };
    }
  
    try {
      const userid = { userId };
      const response = await axiosSecureInstance.post(FETCH_SINGLE_USER_INFO(), userid);
      const teams = response?.data?.user?.teams;
  
      if (!teams || teams.length === 0) {
        return { success: false, error: "No teams data found" };
      }

      return { success: true, data: teams };
    } catch (error) {
      console.error("Error fetching user teams:", error);
      return { success: false, error: error.message || "An error occurred" };
    }
  };
  
  